/** Canonical legal documents live on the product site, not the auth server. */
export const PRIVACY_POLICY_URL = "https://sigmaidentity.com/privacy";
